// ==========================================
// SECTION INDUSTRIES 2 — TOUTES LES DONNÉES STATIQUES ICI
// ==========================================

// EN-TÊTE PAR DÉFAUT
export const defaultHeading = {
  title: "IMPACT CLIENT PROUVÉ",
  subtitle: "Transformer la complexité financière en résultats clairs et actionnables.",
};

// EN-TÊTE SERVICES FINANCIERS
export const financialServicesHeading = {
  title: "NOTRE TRAVAIL EN ACTION",
  subtitle:
    "Concentré sur des résultats qui améliorent la valeur, la résilience et la confiance des investisseurs.",
};

// EN-TÊTE SANTÉ
export const healthcareHeading = {
  title: "DES RÉSULTATS QUI AMÉLIORENT LES SOINS",
  subtitle:
    "Aider les organisations de santé à opérer de manière plus intelligente, plus sûre et plus durable.",
};

// ==========================================
// STATISTIQUES PAR DÉFAUT + CONTENU BLEU
// ==========================================
export const defaultStats = [
  { number: "12,8%", label: "Rendement Annuel Moyen" },
  { number: "98%", label: "Taux de Fidélisation Client" },
  { number: "500+", label: "Clients Institutionnels" },
  { number: "15", label: "Marchés Mondiaux" },
];

export const defaultBlueContent = {
  title: "Naviguer dans la Complexité Financière",
  paragraphs: [
    "Dans le paysage financier en évolution rapide d'aujourd'hui, les institutions sont confrontées à des défis sans précédent en matière de volatilité des marchés, de conformité réglementaire et de transformation numérique.",
    "Nous combinons une connaissance approfondie du secteur avec des analyses de pointe pour fournir des insights qui stimulent une croissance durable et optimisent la gestion des risques.",
  ],
  image: "/assets/images/finance-team.png",
};

// ==========================================
// SANTÉ
// ==========================================
export const healthcareStats = [
  { number: "25%", label: "Dépenses de Santé Gaspillées" },
  { number: "30–40%", label: "Charge Administrative Réduite par la Numérisation" },
  { number: "15–20%", label: "Réduction des Réhospitalisations Évitables" },
  { number: "N/A", label: "Initiatives de Transformation" },
];

export const healthcareBlueContent = {
  title: "COMPRENDRE MIEUX LA SANTÉ",
  paragraphs: [
    "La santé évolue plus rapidement que la plupart des industries, et les dirigeants sont sous pression pour fournir de meilleurs résultats avec des budgets plus serrés et des attentes des patients en hausse. Pestel & Partners réalise cela parfaitement !",
    "Nous aidons les organisations de santé avec des insights financiers solides, des stratégies de flux de travail plus intelligentes et des plans de transformation.",
  ],
  image: "/assets/images/finance-team.png",

  // ⭐ POINTS FORTS AJOUTÉS
  highlights: [
    {
      icon: "/assets/icons/path-to-icon1.png",
      text: "Les organisations de santé gaspillent jusqu'à 25% de leurs dépenses.",
    },
    {
      icon: "/assets/icons/path-to-icon2.png",
      text: "L'adoption numérique peut réduire la charge administrative de 30 à 40%.",
    },
    {
      icon: "/assets/icons/path-to-icon3.png",
      text: "L'analyse prédictive peut réduire les réhospitalisations évitables de 15 à 20%.",
    },
  ],
};

// ==========================================
// GESTION D'ACTIFS
// ==========================================
export const assetManagementStats = [
  { number: "18%", label: "Gains d'Efficacité Opérationnelle" },
  { number: "35%", label: "Réduction de l'Exposition aux Risques" },
  { number: "50+", label: "Engagements de Gestionnaires d'Actifs" },
  { number: "20 ans", label: "Expérience dans le Secteur" },
];

export const assetManagementBlueContent = {
  title: "NAVIGUER DANS LA COMPLEXITÉ DES ACTIFS",
  paragraphs: [
    "Chaque gestionnaire d'actifs atteint un moment où les feuilles de calcul, les mouvements de marché et les demandes des clients ne racontent plus une histoire simple, et naviguer ce moment définit la performance. Avec des marchés qui évoluent plus vite que les modèles traditionnels ne peuvent suivre, les équipes ont besoin de plus que des données ; elles ont besoin de clarté, de direction et de confiance.",
    "C'est là que Pestel & Partners intervient ! Nous soutenons ce changement avec des cadres financiers transparents et des voies de décision pratiques qui rendent l'incertitude gérable et la valeur à long terme plus atteignable.",
  ],
  image: "/assets/images/finance-team.png",
  highlights: [],
};

// ==========================================
// BANQUE
// ==========================================
export const bankingStats = [
  { number: "27%", label: "Réduction des Coûts de Conformité" },
  { number: "40%", label: "Boost de l'Automatisation des Processus" },
  { number: "3x", label: "Onboarding Client Plus Rapide" },
  { number: "75%", label: "Amélioration de l'Expérience Client" },
];

export const bankingBlueContent = {
  title: "NAVIGUER DANS LA NOUVELLE COMPLEXITÉ BANCAIRE",
  paragraphs: [
    "La complexité bancaire ne se manifeste pas d'un coup ; elle s'accumule discrètement à travers les mises à jour réglementaires, l'évolution des besoins clients et la pression de se moderniser plus vite que les concurrents. Notre rôle est d'aider les banques à traverser ce bruit et à se concentrer sur ce qui renforce vraiment la solidité à long terme.",
    "Ce que nous apportons ? Nous apportons de la clarté aux décisions financières, améliorons les processus lents et soutenons les équipes dans la construction d'opérations sécurisées et centrées sur le client qui peuvent naviguer dans l'incertitude sans perdre de l'élan. Avec Pestel & Partners, les banques gagnent un partenaire qui simplifie la complexité et renforce la confiance à chaque étape.",
  ],
  image: "/assets/images/finance-team.png",
  highlights: [],
};

// ==========================================
// CONSEIL FINANCIER
// ==========================================
export const financialAdvisoryStats = [
  { number: "30%", label: "Amélioration de la Vitesse de Décision" },
  { number: "45%", label: "Meilleure Allocation Stratégique" },
  { number: "60%", label: "Impact de Réduction des Risques" },
  { number: "80+", label: "Projets de Conseil Livrés" },
];

export const financialAdvisoryBlueContent = {
  title: "COMPLEXITÉ FINANCIÈRE, SIMPLIFIÉE",
  paragraphs: [
    "La complexité financière n'est pas le défi ; savoir comment naviguer l'est. Les dirigeants d'aujourd'hui font face à des marchés changeants, à des attentes de conformité croissantes et à des décisions qui exigent rapidité et précision.",
    "Nous voilà ! Pestel & Partners apporte de la clarté à ce paysage en transformant les chiffres en insight, l'insight en action et l'action en valeur à long terme. Nos experts en conseil s'associent étroitement avec les clients pour simplifier l'incertitude, renforcer les cadres décisionnels pour une santé financière durable.",
  ],
  image: "/assets/images/finance-team.png",
  highlights: [],
};

// ==========================================
// ## TAXATION DES SERVICES FINANCIERS
// ==========================================
export const financialServiceTaxStats = [
  { number: "22%", label: "Boost de l'Efficacité Fiscale" },
  { number: "35%", label: "Réduction du Risque de Conformité" },
  { number: "50+", label: "Engagements en Stratégie Fiscale" },
  { number: "99%", label: "Exactitude Réglementaire" },
];

export const financialServiceTaxBlueContent = {
  title: "NAVIGUER DANS LA RÉALITÉ FISCALE D'AUJOURD'HUI",
  paragraphs: [
    "Les fonctions fiscales se situent aujourd'hui au centre de la clarté financière, du risque commercial et de la responsabilité réglementaire ; pourtant, la plupart des équipes doivent fournir plus avec un temps limité, un examen accru et des règles en constante évolution. Ce qui était autrefois un exercice de conformité est devenu une responsabilité financière stratégique, influençant les choix d'investissement, les opérations transfrontalières, la planification des flux de trésorerie et la création de valeur à long terme.",
    "Pestel & Partners peut être votre main secourable ! Nous soutenons les organisations dans la navigation de ce changement avec des stratégies fiscales pratiques, transparentes et prêtes pour l'avenir.",
  ],
  image: "/assets/images/finance-team.png",
  highlights: [],
};

// ==========================================
// ## FINTECH
// ==========================================
export const fintechStats = [
  { number: "50%", label: "Passage au Numérique Plus Rapide" },
  { number: "3x", label: "Renforcement des Cadres de Risque" },
  { number: "70%", label: "Boost de la Transparence Opérationnelle" },
  { number: "120+", label: "Projets FinTech Livrés" },
];

export const fintechBlueContent = {
  title: "NAVIGUER DANS LA COMPLEXITÉ FINTECH",
  paragraphs: [
    "La FinTech évolue plus vite que la plupart des entreprises ne peuvent réagir, et chaque nouvelle idée s'accompagne de nouvelles conséquences financières, réglementaires et opérationnelles. C'est pourquoi le vrai défi n'est pas de lancer des produits numériques ; c'est de les développer de manière responsable.",
    "Chez Pestel & Partners, nous aidons les dirigeants FinTech à avancer avec confiance en ancrant l'innovation dans la discipline financière, en renforçant les cadres de risque et en construisant des systèmes transparents que les régulateurs et les clients peuvent croire.",
  ],
  image: "/assets/images/finance-team.png",
  highlights: [],
};

// ==========================================
// ## ASSURANCE
// ==========================================
export const insuranceStats = [
  { number: "25%", label: "Optimisation des Coûts Opérationnels" },
  { number: "40%", label: "Amélioration de l'Efficacité des Sinistres" },
  { number: "3x", label: "Boost de la Confiance Client" },
  { number: "80+", label: "Engagements en Assurance" },
];

export const insuranceBlueContent = {
  title: "GUIDER LES ASSUREURS DANS L'INCERTITUDE MODERNE",
  paragraphs: [
    "Les clients veulent une assurance qui semble fiable, facile à comprendre et réactive quand la vie change de manière inattendue. Mais derrière les coulisses, les assureurs font face à des coûts de sinistres en hausse, des règles plus strictes et la pression d'innover rapidement. Mais ce n'est pas la fin !",
    "Comptez sur Pestel & Partners ! Nous travaillons en étroite collaboration avec les dirigeants d'assurance pour renforcer les contrôles financiers, rationaliser les processus et concevoir des stratégies qui améliorent la confiance des clients tout en maintenant les opérations résilientes.",
  ],
  image: "/assets/images/finance-team.png",
  highlights: [],
};

// ==========================================
// ## AUTRES SECTEURS
// ==========================================
export const oilAndGasStats = [
  { number: "22%", label: "Réduction des Coûts Atteinte" },
  { number: "40%", label: "Cycles de Reporting Plus Rapides" },
  { number: "5000+", label: "Actifs Surveillés Numériquement" },
  { number: "12", label: "Programmes d'Efficacité Opérationnelle" },
];

export const oilAndGasBlueContent = {
  title: "RÉINVENTER LE POSSIBLE DANS LE PÉTROLE & GAZ",
  paragraphs: [
    "Les dépenses en amont dépassent 1,4 billion de dollars annuellement, et les entreprises ont besoin de stratégies financières plus intelligentes.",
  ],
  image: "/assets/images/finance-team.png",
  highlights: [
    {
      icon: "/assets/icons/path-to-icon1.png",
      text: "Les outils numériques réduisent les coûts d'exploitation jusqu'à 15%.",
    },
    {
      icon: "/assets/icons/path-to-icon2.png",
      text: "Les systèmes prédictifs réduisent les temps d'arrêt de 30%.",
    },
    {
      icon: "/assets/icons/path-to-icon3.png",
      text: "L'adoption ESG stimule l'intérêt des investisseurs de 25%.",
    },
  ],
};

export const powerAndUtilitiesStats = [
  { number: "15–20%", label: "Amélioration de la Fiabilité du Réseau" },
  { number: "25%", label: "Réduction des Perturbations en Pics de Charge" },
  { number: "20–30%", label: "Réduction de la Durée des Pannes" },
  { number: "10–12%", label: "Boost de l'Efficacité du Système" },
];

export const powerAndUtilitiesBlueContent = {
  title: "TRANSFORMER LES SERVICES PUBLICS POUR UN AVENIR ÉNERGÉTIQUE",
  paragraphs: [
    "Le secteur des services publics évolue vers l'électrification, des réseaux plus intelligents et les énergies renouvelables.",
  ],
  image: "/assets/images/finance-team.png",
  highlights: [
    {
      icon: "/assets/icons/path-to-icon1.png",
      text: "Les réseaux intelligents réduisent la durée des pannes de 20 à 30%.",
    },
    {
      icon: "/assets/icons/path-to-icon2.png",
      text: "La mesure numérique réduit les pertes opérationnelles jusqu'à 18%.",
    },
    {
      icon: "/assets/icons/path-to-icon3.png",
      text: "L'intégration des énergies renouvelables améliore l'efficacité du système de 10 à 12%.",
    },
  ],
};

export const wasteManagementStats = [
  { number: "10%", label: "Réduction des Coûts de Traitement" },
  { number: "15–25%", label: "Amélioration de l'Efficacité" },
  { number: "30%", label: "Réduction de la Dépendance aux Décharges" },
  { number: "3,4 Md", label: "Tonnes de Déchets Mondiaux d'ici 2050" },
];

export const wasteManagementBlueContent = {
  title: "CONCEVOIR L'AVENIR DE LA GESTION RESPONSABLE DES DÉCHETS",
  paragraphs: [
    "Les organisations doivent se moderniser rapidement pour répondre aux attentes réglementaires et environnementales.",
  ],
  image: "/assets/images/finance-team.png",
  highlights: [
    {
      icon: "/assets/icons/path-to-icon1.png",
      text: "Réduire les coûts de traitement jusqu'à 20%.",
    },
    {
      icon: "/assets/icons/path-to-icon2.png",
      text: "Réduire les inefficacités de collecte des déchets de 15 à 25%.",
    },
    {
      icon: "/assets/icons/path-to-icon3.png",
      text: "Les modèles de recyclage réduisent la dépendance aux décharges de 30%.",
    },
  ],
};

export const miningAndMineralsStats = [
  { number: "4x", label: "Demande en Minéraux d'ici 2040" },
  { number: "30%", label: "Réduction des Temps d'Arrêt" },
  { number: "20%", label: "Coûts d'Exploitation Inférieurs" },
  { number: "N/A", label: "Programmes de Transformation" },
];

export const miningAndMineralsBlueContent = {
  title: "FAÇONNER L'AVENIR DE L'EXTRACTION MINÉRALE",
  paragraphs: [
    "Les outils numériques, les flux de travail automatisés et le reporting transparent ne sont plus des 'plans futurs' — ils sont la colonne vertébrale d'une production stable et d'une création de valeur à long terme. Pestel & Partners aide les équipes minières à rendre cette transition pratique et réalisable, en construisant des stratégies de transformation qui renforcent les marges, réduisent les risques et préparent les opérations pour la prochaine décennie de demande minérale.",
  ],
  image: "/assets/images/finance-team.png",
  highlights: [
    {
      icon: "/assets/icons/path-to-icon1.png",
      text: "La demande mondiale en minéraux devrait quadrupler d'ici 2040.",
    },
    {
      icon: "/assets/icons/path-to-icon2.png",
      text: "La maintenance prédictive réduit les temps d'arrêt des équipements jusqu'à 30%.",
    },
    {
      icon: "/assets/icons/path-to-icon3.png",
      text: "Les systèmes de transport autonomes offrent des coûts d'exploitation inférieurs de 15 à 20%.",
    },
  ],
};

// =========================== DONNÉES SCIENCES DE LA VIE

export const lifeScienceHeading = {
  title: "DES RÉSULTATS DIGNES DE CONFIANCE",
  subtitle:
    "Apporter clarté, contrôle et confiance à travers toute la chaîne de valeur des sciences de la vie.",
};
export const lifeScienceStats = [
  { number: "35%", label: "Augmentation des Coûts de R&D sur la Dernière Décennie" },
  { number: "6–8%", label: "Croissance Annuelle Mondiale de R&D Attendue" },
  { number: "40%", label: "Temps de Développement en Phase Précoce Réduit via l'IA" },
  { number: "25–30%", label: "Erreurs de Conformité Réduites via les Systèmes Numériques" },
];

export const lifeScienceBlueContent = {
  title: "NAVIGUER DANS LA COMPLEXITÉ SCIENTIFIQUE",
  paragraphs: [
    "Avec des coûts de R&D augmentant de plus de 35% au cours de la dernière décennie, les organisations ont besoin d'une prise de décision plus fine et d'une discipline opérationnelle plus forte. Pestel & Partners soutient les entreprises des sciences de la vie avec des stratégies financières prêtes pour le marché pour un avenir durable.",
  ],
  image: "/assets/images/finance-team.png",

  highlights: [
    {
      icon: "/assets/icons/path-to-icon1.png",
      text: "Les dépenses mondiales de R&D en sciences de la vie devraient croître de 6 à 8% annuellement.",
    },
    {
      icon: "/assets/icons/path-to-icon2.png",
      text: "La découverte de médicaments par IA peut réduire le temps de développement en phase précoce jusqu'à 40%.",
    },
    {
      icon: "/assets/icons/path-to-icon3.png",
      text: "Les systèmes de qualité numérique réduisent les erreurs de conformité de 25 à 30%.",
    },
  ],
};

export const privateEquityHeading = {
  title: "UNE VALEUR MESURABLE",
  subtitle:
    "Générer des résultats financiers mesurables à travers les transactions, les portefeuilles et les sorties.",
};
export const privateEquityStats = [
  { number: "35%", label: "Augmentation des Coûts de R&D sur la Dernière Décennie" },
  { number: "6–8%", label: "Croissance Annuelle Mondiale de R&D Attendue" },
  { number: "40%", label: "Temps de Développement en Phase Précoce Réduit via l'IA" },
  { number: "25–30%", label: "Erreurs de Conformité Réduites via les Systèmes Numériques" },
];
export const privateEquityBlueContent = {
  title: "NAVIGUER DANS LA COMPLEXITÉ DU CAPITAL-INVESTISSEMENT",
  paragraphs: [
    "Le capital-investissement opère aujourd'hui dans l'un des environnements les plus complexes que l'industrie ait jamais connus. La concurrence sur les transactions a augmenté de 40% au cours des cinq dernières années ; la trésorerie disponible dépasse 2,6 billions de dollars à l'échelle mondiale, et les investisseurs exigent une création de valeur plus rapide et plus transparente.",
  ],
  image: "/assets/images/finance-team.png",
  highlights: [
    {
      icon: "/assets/icons/path-to-icon1.png",
      text: "Les cycles de transaction sont 35 à 50% plus courts qu'il y a dix ans.",
    },
    {
      icon: "/assets/icons/path-to-icon2.png",
      text: "73% des dirigeants en capital-investissement signalent une complexité opérationnelle croissante.",
    },
    {
      icon: "/assets/icons/path-to-icon3.png",
      text: "La création de valeur dans les portefeuilles contribue désormais à plus de 50% du rendement total.",
    },
  ],
};
export const professionalServiceHeading = {
  title: "DES RÉSULTATS DIGNES DE CONFIANCE",
  subtitle:
    "Permettre aux cabinets de services professionnels d'améliorer leur performance de livraison.",
};
export const professionalServiceStats = [
  { number: "35%", label: "Augmentation des Coûts de R&D sur la Dernière Décennie" },
  { number: "6–8%", label: "Croissance Annuelle Mondiale de R&D Attendue" },
  { number: "40%", label: "Temps de Développement en Phase Précoce Réduit via l'IA" },
  { number: "25–30%", label: "Erreurs de Conformité Réduites via les Systèmes Numériques" },
];
export const professionalServiceBlueContent = {
  title: "COMPRENDRE MIEUX LES CABINETS PROFESSIONNELS",
  paragraphs: [
    "Dans les services professionnels, un maillon faible affecte l'ensemble du cabinet. Ce dont les dirigeants ont besoin, c'est de clarté, pas de complexité. Pestel & Partners aide les cabinets à reconstruire la structure, à aiguiser la performance et à créer des modèles de service qui se renforcent avec le temps.",
  ],
  image: "/assets/images/finance-team.png",
  highlights: [
    {
      icon: "/assets/icons/path-to-icon1.png",
      text: "Les cabinets perdent 8 à 12% de leur chiffre d'affaires annuel en raison d'une mauvaise planification des capacités.",
    },
    {
      icon: "/assets/icons/path-to-icon2.png",
      text: "Près de 40% des retards de projet proviennent de flux de travail fragmentés.",
    },
    {
      icon: "/assets/icons/path-to-icon3.png",
      text: "Les écarts de tarification et les coûts de livraison croissants réduisent les marges bénéficiaires de 6 à 9%.",
    },
  ],
};
export const publicSectorBlueContentHeading = {
  title: "DES RÉSULTATS DIGNES DE CONFIANCE",
  subtitle:
    "Permettre aux institutions publiques d'opérer avec plus de transparence et d'efficacité.",
};
export const publicSectorBlueContentStats = [
  { number: "35%", label: "Augmentation des Coûts de R&D sur la Dernière Décennie" },
  { number: "6–8%", label: "Croissance Annuelle Mondiale de R&D Attendue" },
  { number: "40%", label: "Temps de Développement en Phase Précoce Réduit via l'IA" },
  { number: "25–30%", label: "Erreurs de Conformité Réduites via les Systèmes Numériques" },
];
export const publicSectorBlueContent = {
  title: "RENFORCER LES SYSTÈMES PUBLICS",
  paragraphs: [
    "Les défis du secteur public se chevauchent souvent. La pression budgétaire affecte la qualité du service, des données fragmentées ralentissent les décisions et les lacunes numériques impactent la transparence. Pestel & Partners aide les gouvernements à renforcer les opérations et à construire des services publics plus réactifs et résilients.",
  ],
  image: "/assets/images/finance-team.png",
  highlights: [
    {
      icon: "/assets/icons/path-to-icon1.png",
      text: "Jusqu'à 35 à 45% des arriérés de services publics.",
    },
    {
      icon: "/assets/icons/path-to-icon2.png",
      text: "Les gouvernements perdent 8 à 12% de leurs dépenses annuelles.",
    },
    {
      icon: "/assets/icons/path-to-icon3.png",
      text: "Près de 60% des institutions publiques signalent une visibilité limitée des données en temps réel.",
    },
  ],
};
export const realEstateConstructionBlueHeading = {
  title: "DES RÉSULTATS QUI COMPTENT",
  subtitle:
    "Transformer la complexité des projets en gains mesurables de construction et de portefeuille.",
};
export const realEstateConstructionBlueStats = [
  { number: "35%", label: "Augmentation des Coûts de R&D sur la Dernière Décennie" },
  { number: "6–8%", label: "Croissance Annuelle Mondiale de R&D Attendue" },
  { number: "40%", label: "Temps de Développement en Phase Précoce Réduit via l'IA" },
  { number: "25–30%", label: "Erreurs de Conformité Réduites via les Systèmes Numériques" },
];
export const realEstateConstructionBlueContent = {
  title: "CLARTÉ DANS LES DÉCISIONS DE PROJETS DE CONSTRUCTION",
  paragraphs: [
    "Les défis dans l'immobilier et la construction se présentent rarement seuls — les coûts croissants influencent la trésorerie, les retards impactent la confiance des investisseurs et les angles morts opérationnels ralentissent chaque projet. Pestel & Partners aide les organisations à construire des résultats de projet plus prévisibles et résilients.",
  ],
  image: "/assets/images/finance-team.png",
  highlights: [
    {
      icon: "/assets/icons/path-to-icon1.png",
      text: "Près de 70% des projets de construction dépassent le budget.",
    },
    {
      icon: "/assets/icons/path-to-icon2.png",
      text: "Des études du secteur montrent que 60 à 80% des projets connaissent des retards de planning.",
    },
    {
      icon: "/assets/icons/path-to-icon3.png",
      text: "Jusqu'à 30% des coûts des projets peuvent être liés à des retouches.",
    },
  ],
};
export const mediaEntertainmentHeading = {
  title: "DES RÉSULTATS POUR LES LEADERS DES MÉDIAS",
  subtitle:
    "Offrir des pipelines de contenu plus solides, des audiences engagées et des modèles de revenus stables.",
};

export const mediaEntertainmentStats = [
  { number: "5–7", label: "Plateformes Moyennes Utilisées par les Audiences Mondiales" },
  { number: "20–30%", label: "Hausse des Budgets de Contenu Scénarisé" },
  { number: "55%", label: "Revenus des Médias Provenant du Numérique & du Streaming" },
  { number: "40%", label: "Augmentation des Coûts de Production Multi-Plateformes" },
];

export const mediaEntertainmentBlueContent = {
  title: "RENDRE LE PAYSAGE DU DIVERTISSEMENT PLUS CLAIR",
  paragraphs: [
    "Les médias changent plus vite que les entreprises ne peuvent s'adapter ; les audiences sautent souvent de plateformes, les coûts de production augmentent chaque année et les modèles de revenus numériques ne restent jamais les mêmes très longtemps. Pestel & Partners aide les entreprises médias à traverser le bruit du secteur et à prendre des décisions fondées, pas basées sur des suppositions.",
  ],
  image: "/assets/images/finance-team.png",
  highlights: [
    {
      icon: "/assets/icons/path-to-icon1.png",
      text: "Les audiences mondiales regardent désormais du contenu sur 5 à 7 plateformes en moyenne.",
    },
    {
      icon: "/assets/icons/path-to-icon2.png",
      text: "Les budgets de production scénarisée ont augmenté de 20 à 30%.",
    },
    {
      icon: "/assets/icons/path-to-icon3.png",
      text: "Le numérique et le streaming contribuent désormais à plus de 55% du total des revenus des médias.",
    },
  ],
};
export const telecommunicationHeading = {
  title: "UNE PERFORMANCE ORIENTÉE RÉSULTATS",
  subtitle: "Aider les opérateurs à améliorer le ROI du réseau et à construire des modèles financiers plus solides.",
};

export const telecommunicationStats = [
  { number: "25–30%", label: "Croissance Annuelle de la Consommation de Données Mobiles" },
  { number: "18–25%", label: "Taux de Désabonnement Moyen des Utilisateurs Télécom" },
  { number: "20–25%", label: "Hausse des Coûts d'Infrastructure 5G" },
  { number: "40%", label: "Augmentation de la Charge du Réseau dans les Villes à Fort Trafic" },
];

export const telecommunicationBlueContent = {
  title: "RENDRE LA COMPLEXITÉ TÉLÉCOM PLUS CLAIRE",
  paragraphs: [
    "Les leaders des télécommunications luttent aujourd'hui avec les charges réseau, les baisses de service et les décisions d'investissement changeantes du jour au lendemain. Pestel & Partners aide les opérateurs à traverser cette complexité avec des insights plus clairs pour la prochaine ère de la connectivité.",
  ],
  image: "/assets/images/finance-team.png",
  highlights: [
    {
      icon: "/assets/icons/path-to-icon1.png",
      text: "La consommation de données mobiles a augmenté de 25 à 30% annuellement.",
    },
    {
      icon: "/assets/icons/path-to-icon2.png",
      text: "Les taux de désabonnement télécom se situent en moyenne entre 18 et 25%.",
    },
    {
      icon: "/assets/icons/path-to-icon3.png",
      text: "Les coûts d'infrastructure 5G ont augmenté de 20 à 25%.",
    },
  ],
};
export const technologyHeading = {
  title: "RÉUSSITE NUMÉRIQUE LIVRÉE",
  subtitle: "Aider les entreprises technologiques à débloquer une forte fidélisation client et une croissance durable.",
};

export const technologyStats = [
  { number: "60%", label: "Équipes Tech Signalant des Sorties Lentes" },
  { number: "25–35%", label: "Budgets Cloud Perdus Annuellement" },
  { number: "15–25%", label: "Taux de Désabonnement Moyen des Produits SaaS" },
  { number: "10–15%", label: "Ralentissement du Cycle de Dev dû à la Fragmentation" },
];

export const technologyBlueContent = {
  title: "CLARTÉ DANS LES DÉCISIONS TECHNOLOGIQUES",
  paragraphs: [
    "Les entreprises technologiques opèrent dans un paysage de nouveaux concurrents, d'outils changeants et d'attentes client en évolution rapide chaque trimestre.",
    "Pestel & Partners aide les leaders tech à trouver de la clarté sur ce qui stimule vraiment la croissance.",
  ],
  image: "/assets/images/finance-team.png",
  highlights: [
    {
      icon: "/assets/icons/path-to-icon1.png",
      text: "Plus de 60% des équipes tech mentionnent des sorties de produits lentes.",
    },
    {
      icon: "/assets/icons/path-to-icon2.png",
      text: "Les entreprises perdent 25 à 35% de leurs budgets cloud.",
    },
    {
      icon: "/assets/icons/path-to-icon3.png",
      text: "Les produits SaaS connaissent un désabonnement annuel de 15 à 25%.",
    },
  ],
};